import Pusher from 'pusher-js';
import { getPusherConfig } from 'Services/Applications/Application';
import { DOMAIN, LoggerFactory } from 'Services/Logger';

const Logger = LoggerFactory.getLogger(DOMAIN.FUNNEL);

let pusherPromise = null;
class KueskiPusher {
  /**
   * Connect with pusher service, first retrives the credentials from the backend and then establish
   * a connection with the pusher service.
   */
  static getPusherChannel() {
    if (pusherPromise == null) {
      pusherPromise = new Promise((resolve, reject) => {
        getPusherConfig()
          .then((response) => {
            try {
              const {
                data: {
                  app_key: appKey,
                  cluster,
                  channel: privateChannel,
                },
                auth,
              } = response;
              const pusherConnection = KueskiPusher.connectWithPusher(appKey, cluster, auth);

              pusherConnection.connection.bind('unavailable', () => {
                Logger.warn('Pusher: The connection is temporarily unavailable', 'pusher.disconnect');
              });

              pusherConnection.connection.bind('failed', () => {
                Logger.warn('Pusher: Channels is not supported by the browser', 'pusher.not_available');
              });

              resolve(pusherConnection.subscribe(privateChannel));
            } catch (exception) {
              reject(exception);
            }
          })
          .catch(error => reject(error));
      });
    }

    return pusherPromise;
  }

  /**
  * Given the configuration for pusher creates a new connection with the given private channel
  */
  static connectWithPusher(appKey, cluster, auth) {
    return new Pusher(appKey, {
      auth: {
        headers: {
          Authorization: auth.bearer,
        },
      },
      authEndpoint: `${auth.domain}/v1/protected/pusher/auth`,
      cluster,
      encrypted: true,
    });
  }
}

export default KueskiPusher;
